<template>
    <div class="col-lg-12">
    <v-dialog
      v-model="dialog"
      scrollable
      max-width="75%"
    >
      <v-card flat>
        <v-card-title class="py-0">
          <h4 class="title">{{ existingContacts.length }} numéros existant détectés.</h4>
          <span class="caption">(Veuillez bien les supprimer avant de continuer l'importation)</span>
          <v-spacer />
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <v-data-table
                :items="existingContacts"
                class=""
                hide-default-header
                hide-default-footer
              >
              <template v-slot:headers="props">
                  <tr>
                    <!-- <th>
                      <v-checkbox
                        :input-value="props.all"
                        :indeterminate="props.indeterminate"
                        primary
                        hide-details
                        @click="toggleAll"
                      ></v-checkbox>
                    </th> -->
                    <th
                      v-for="header in props.headers"
                      :key="header.value"
                      :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                    >
                      <v-icon small>mdi-arrow-up</v-icon>
                      {{ header.text }}
                    </th>
                  </tr>
                </template>
                <template v-slot:items="props">
                  <tr :active="props.selected" class="table">
                    <!-- <td>
                      <v-checkbox
                        :input-value="props.selected"
                        primary
                        hide-details
                      ></v-checkbox>
                    </td> -->
                    <td> {{ props.index + 1 }} </td>
                    <td >{{ props.item.first_name }} {{ props.item.last_name }}</td>
                    <td >{{ props.item.contact }}</td>
                    <td >{{ props.item.language }}</td>
                    <!-- <td >{{ props.item.departement }}</td>
                    <td >{{ props.item.commune }}</td>
                    <td >{{ props.item.village }}</td> -->
                  </tr>
                </template>
              </v-data-table>
              <div class="text-xs-center pt-2">
                <v-pagination v-model="mxCurrentPage" :total-visible="6" :length="pages"></v-pagination>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
        <v-card class="mx-auto" flat>
            <v-card-title>Importer la liste des acteurs depuis un fichier CSV</v-card-title>
            <v-card-text>
                <vue-csv-import @cleared="clear()" loadBtnText="Charger le fichier"	 v-model="importedData" :map-fields="heads"></vue-csv-import>
                <div class="pt-2">
                    <v-btn rounded :disabled="importedData.length==0" :loading="uploading" class="primary" @click.prevent="submit()">
                    <i class="fa fa-save"> </i> Enregister
                    <template v-slot:loader>
                        <span>
                        {{ progression }}%
                        <v-progress-circular width="2" size="20" color="" indeterminate :value="20"></v-progress-circular>
                        </span>
                    </template>
                    </v-btn>
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import VueCsvImport from '~/components/VueCsvImport.vue'
import axios from "axios"

export default {
  name: 'import',
  components: {
    VueCsvImport
  },
  data(){
    return {
      actors:[],
      importedData: [],
      dialog: false,
      existingContacts: [],
      uploading: false,
      progression: 0,
      pages: 1,
      mxCurrentPage: 1,
      heads: {
        last_name: 'Nom',
        first_name: 'Prénom',
        gender: 'Sexe',
        age: 'Age',
        language: 'langue',
        instruction_level: 'Niveau d\'instruction',
        type: 'Type d\'acteur',
        photo_url: 'Photo',
        maillon: 'Maillon',
        value_chain: 'Chaine de valeur',
        department: 'Department',
        municipality: 'Commune',
        district: 'Arrondissement',
        town: 'Ville/Village',
        town_other: 'Autre Village',
        address: 'Adresse',
        contact: 'Contact',
        longitude: 'Longitude',
        latitude: 'Latitude',
        altitude: 'Altitude',
        precision: 'Precision',
     }
    }
  },
  computed:{
  },
  methods:{

    clear(){
      this.importedData=[]
    },

    chunkArray(myArray, chunk_size){
      var index = 0;
      var arrayLength = myArray.length;
      var tempArray = [];

      for (index = 0; index < arrayLength; index += chunk_size) {
          let myChunk = myArray.slice(index, index+chunk_size);
          // Do something if you want with the group
          tempArray.push(myChunk);
      }

      return tempArray;
    },

    async submitNextChunk(dataChunks, index){
      let totalChunks = dataChunks.length
      if(totalChunks > 0) {
        let chunk = dataChunks[index]
        await  axios.post('/api/actors/csv', this.importedData).then(async resp => {
          this.progression = Math.floor(((index + 1)/totalChunks)*100)
          // console.log('Response data', resp.data)
          if (resp.data.existing_actors) {
            this.existingContacts.push(resp.data.existing_actors)
          }
          if (index !== totalChunks-1){
           await this.submitNextChunk(dataChunks, index + 1)
          }
          else{
            if (this.existingContacts.length !== 0) {
              let message = 'Importation effectuée.\n Toutefois, des doublons ont été détectés.'
               this.$store.dispatch('responseMessage', {
               type: 'yellow',
                text: message,
               })
              this.uploading = false
              this.dialog = true
            }
            setTimeout(() =>{
              // Redirect to the actors list.
            //   this.$router.push({ name: 'actors.list' })
            //   this.$store.dispatch('responseMessage', {
            //    type: 'green',
            //     text: 'Acteurs importés avec succès!',
            //    })
            }, 10000)
          }
        }).catch(err =>{
          console.log(err)
          let message = 'Une erreur s\'est produite lors de l\'importations des acteurs'
           this.$store.dispatch('responseMessage', {
              type: 'red',
              text: message,
            })
          this.uploading = false
        });
      }
    },

 	async submit(){
        let dataChunks = this.chunkArray(this.importedData, 500)
        if (dataChunks.length !== 0) {
            this.uploading = true
            this.existingContacts = []
            await this.submitNextChunk(dataChunks, 0)
        }
    }

  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/actors/import.vue